import Vue from 'vue';
import firebase from 'firebase';

export function getUserConfig(env, username) {
  const domain = 'https://qx0nowybrl.execute-api.us-east-1.amazonaws.com';
  const path = `${env}/getConfiguration`;
  const url = `${domain}/${path}`;
  const params = {
    username: encodeURIComponent(username),
  };
  return Vue.http.get(url, { params });
}

export function getUser() {
  return firebase.auth().currentUser;
}

export function onAuthChange(callback) {
  return firebase.auth().onAuthStateChanged(callback);
}

export function signInWithEmail(username, password) {
  return firebase.auth().signInWithEmailAndPassword(username, password);
}

export function signInAnonymously() {
  return firebase.auth().signInAnonymously();
}
export function signInWithGoogle() {
  const provider = new firebase.auth.GoogleAuthProvider();
  provider.setCustomParameters({ hd: 'impactanalytics.co' });
  return firebase.auth().signInWithPopup(provider);
}

export function signOut() {
  return firebase.auth().signOut();
}

export function getCurrentUser() {
  return firebase.auth().currentUser;
}

export function getCredentail(email, password) {
  return firebase.auth.EmailAuthProvider.credential(email, password);
}

export function sendPasswordResetEmail(email) {
  return firebase.auth().sendPasswordResetEmail(email);
}



// WEBPACK FOOTER //
// ./src/api/authentication.js